import { gunterzBold } from '@/theme/fonts';
import { ActionIcon, Card, Group, Image, Stack, Text } from '@mantine/core';
import { IconArrowUpRight } from '@tabler/icons-react';
import Link from 'next/link';
import type { BlogType } from './blogs';
export const BlogCard: React.FC<BlogType> = ({
  id,
  thumb,
  date,
  title,
  description
}) => {
  return <Card radius={5} bg="var(--bg-200)" component={Link} href={`/blog/${id}`} style={{
    cursor: 'pointer'
  }}>
      <Card.Section>
        <Image src={thumb} alt="blog" />
      </Card.Section>

      <Stack pt={24} gap={10}>
        <Text fz={11} c="var(--text-grey-2)" fw={700} tt="uppercase">
          {date}
        </Text>
        <Group justify="space-between" wrap="nowrap">
          <Text lineClamp={1} fz={{
          base: 14,
          sm: 18,
          lg: 20
        }} className={gunterzBold.className} c="var(--text-white)">
            {title}
          </Text>
          <ActionIcon variant="transparent">
            <IconArrowUpRight size={24} color="var(--text-white)" />
          </ActionIcon>
        </Group>
        <Text fz={13} c="var(--text-dark)" fw={500} lineClamp={4}>
          {description}
        </Text>
      </Stack>
    </Card>;
};